import React from "react"
import styled from "styled-components"
import breakpoints from "@constants/breakpoints"
import * as R from "ramda"

const Container = styled.div`
  padding: 88px 20px 44px;

  @media ${breakpoints.tablet} {
    padding: calc(1 / 12 * 100vw) calc(1 / 12 * 100vw) calc(1 / 12 * 100vw);
  }

  @media ${breakpoints.laptop} {
    padding: calc(1 / 12 * 100vw) calc(1 / 12 * 100vw) calc(1 / 12 * 100vw);
  }
`

interface CodeSnippetProps {
  blockId?: string
  cleanupId?: string
  code: string
}

const CodeSnippet: React.FC<CodeSnippetProps> = ({
  blockId,
  cleanupId,
  code,
}) => {
  const containerRef = React.useRef<HTMLDivElement>(null)
  const scripts = []

  const runScripts = (scripts) => {
    R.forEach((script: HTMLScriptElement) => {
      const src = script.innerText
      const fn = new Function("require", src)
      fn()
    }, scripts)
  }

  React.useEffect(() => {
    const scripts =
      containerRef &&
      containerRef.current &&
      containerRef.current.getElementsByTagName("script")

    runScripts(scripts)

    return () => {
      if (cleanupId) {
        const element = document.getElementById(cleanupId)
        if (element) {
          element.remove()
        }
      }
    }
  }, [])

  return (
    <Container
      id={blockId || undefined}
      ref={containerRef}
      dangerouslySetInnerHTML={{ __html: code }}
    />
  )
}

export default CodeSnippet
